import {generalRequest} from "@/lib/services/requests";
import {useMutation} from "@tanstack/react-query";

export const useApiCreateStudentEquivalent = () => {
    return useMutation({
        mutationFn: (args) =>
            ((async (config = {}) => {
                return generalRequest.post(`/student/equivalent`, config)
            })(args))
    });

}


